module.exports = __webpack_public_path__ + "static/media/webfont.ea3ed652.eot";